// Widget-Plugin: Icon
vcDashboardRegistry.register("icon", {
    noTitle: true,
    defaults: { w: 4, h: 4, resizable: true, copyable: true, showSettings: false },
    render: function ($container, item) {
        var iconClass = item.icon || "fa-circle-question";
        var title = item.title || "";
        $container.html(
            "<div class='dashboard-icon-wrapper'>" +
                "<i class='fa-solid " + iconClass + " dashboard-icon-symbol'></i>" +
                "<span class='dashboard-icon-label'>" + title + "</span>" +
            "</div>"
        );
    },
    init: function ($item, settings) {
    }
});
